import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import nbrApi from '../../../services/nbrApi'
import { useSelector } from 'react-redux'
import EditableTable from './EditableTable'
import Swal from 'sweetalert2'

function ForcastTables() {
  const [properties, setProperties] = useState([])
  const [forecastDetails, setForecastDetails] = useState([])
  const selectedLoginData = useSelector(state => state.auth.loginData)
  const [forecastOptions, setForecastOptions] = useState()
  const [selectedForecast, setSelectedForecast] = useState({})
  const [formData, setFormData] = useState({
    external_id: null,
    properties_id: null,
    week_ending: new Date(),
    detail_date: new Date(),
    status_val: null,
    forecasts_id: null,
    day_of_week_index: 1,
    total_checkouts: 0,
    early_checkouts: 0,
    late_checkouts: 0,
    stayovers: 0,
    group_checkouts: 0,
    total_checkins: 0,
    early_checkins: 0,
    late_checkins: 0,
    group_checkins: 0,
    vips: 0,
    offline_rooms: 0,
    available_rooms: 0,
    occupied_rooms_prev_day: 0,
    occupied_rooms_eod: 0,
    occupancy_rate_available_eod: 0,
    occupancy_rate_total_eod: 0,
    unsold_rooms: 0,
    detail_version: 1
  });

  // inital API calls
  useEffect(() => {
    // fetch
    fetchForecastList()
    getPropertyDropdownData()
  }, [])

  // handle input changes
  const handleInputChange = (name, value) => {
    // if (name === 'forecasts_id') {
    //   setKeyCount(value?.key_count)
    // }
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  // fetch from API
  const fetchForecastList = async () => {
    const res = await nbrApi.post('/getforecastlist', { properties_id: selectedLoginData.properties_id })
    if (res.data) {
      setForecastOptions(res?.data?.map(e => {
        return {
          ...e,
          value: e?.f_id,
          label: e?.week_ending + ' ~ ' + e?.status_val
        }
      }))
    }
  }

  // properties list
  async function getPropertyDropdownData() {
    try {
      const response = await nbrApi.post('/listproperties')

      const data = response.data
      setProperties(data?.map(e => {
        return {
          ...e,
          value: e?.pk_id,
          label: e?.property_name
        }
      }))
    } catch (error) {
      console.error(error)
    }
  }

  // handle select forecast
  const handleForecastSelect = (value) => {
    setSelectedForecast(value)
  }

  // fetch forecast details => on select Forecast
  useEffect(() => {
    if (selectedForecast?.value) {
      const fetchForecastDetails = async () => {
        let payload = {
          properties_id: Number(selectedLoginData?.properties_id),
          f_id: Number(selectedForecast?.value),
          current_version: selectedForecast?.current_version ? Number(selectedForecast?.current_version) : 1
        }
        const res = await nbrApi.post('/getforecastdetail', payload)
        if (res?.data?.length === 0) {
          Swal.fire({
            title: "Information",
            text: "Forecast details not found",
            icon: "info",
            timer: 2000,
            buttons: false,
            showConfirmButton: false,
          });
        } else {
          if (res?.data) {
            setForecastDetails(res?.data)
          } else {
            setForecastDetails([])
          }
        }
      }

      fetchForecastDetails()
    }
  }, [selectedForecast])

  const handleSubmit = async (data, type) => {
    const res = await nbrApi.post('/updateforecastdetail', data)
    if (res?.data) {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: `Forecast ${type === 'create' ? 'Created' : 'Updated'} Successful`,
        showConfirmButton: false,
        timer: 2000,
      })
    } else {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'failed',
        showConfirmButton: false,
        timer: 2000,
      })
    }
  }

  // render
  return (
    <>
      <div className='col-lg-3 mx-auto'>
        {/* Top Filter */}
        <div className='d-lg-flex gap-2'>
          <div className="form-group w-100">
            <label htmlFor="forecasts_id" className='text-secondary fw-semibold'>Select Forecast</label>
            <Select
              id="forecasts_id"
              options={forecastOptions}
              className='text-secondary'
              onChange={handleForecastSelect}
            />
          </div>
          {/* <div className="form-group w-100">
            <label htmlFor="properties_id" className='text-secondary fw-semibold'>Properties</label>
            <Select
              id="properties_id"
              value={properties?.find(e => e?.value === Number(selectedLoginData?.properties_id))}
              options={properties}
              isDisabled={true}
              className='text-secondary'
              onChange={option => handleInputChange('properties_id', option ? option.value : null)}
            />
          </div> */}
        </div>
      </div>
      <div className='col-lg-12 mx-auto'>
        {/* Table view => Forecast Details */}
        {
          selectedForecast?.value && forecastDetails?.length > 0 && (
            <div className=''>
              <EditableTable initialData={forecastDetails} totalRooms={selectedForecast?.key_count} handleSubmit={handleSubmit} />
            </div>
          )
        }
      </div>
    </>

  )
}

export default ForcastTables